import { useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import CampaignsPage from './pages/Campaigns/CampaignsPage';
import EntitlementsPage from './pages/EntitlementsPage';
import ProfilePage from './pages/ProfilePage';
import SettingsPage from './pages/SettingsPage';
import PaywallPage from './pages/PaywallPage';
import { NavigationProvider, useNavigation } from './navigation/NavigationProvider';

const ScreenRouter = () => {
  const { path, navigate } = useNavigation();
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'GoBack' || e.code === 'Escape') {
        e.stopPropagation();
        const route = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : window.location.hash;
        if (route !== '' && route !== '/') {
          window.history.back();
        }
      }
    }
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [navigate, path]);

  if (path.startsWith('/paywall')) {
    return <PaywallPage />;
  }

  switch (path) {
    case '/':
      return <CampaignsPage />;
    case '/profile':
      return <ProfilePage />;
    case '/entitlements':
      return <EntitlementsPage />;
    case '/settings':
      return <SettingsPage />;
    default:
      return <CampaignsPage />;
  }
};

function App() {
  return (
    <NavigationProvider>
      <div className="app-shell">
        <Header />
        <main>
          <ScreenRouter />
        </main>
      </div>
    </NavigationProvider>
  );
}

export default App;
